import moment from 'moment';

export const getAge = (dateOfBirth:string) => Math.ceil(moment(moment()
    .format('YYYY-MM-DD'))
    .diff(moment(dateOfBirth), 'years', true));
